const USER_COLORS = [
  "#2196F3", // Blue
  "#9C27B0", // Purple
  "#4CAF50", // Green
  "#FF9800", // Orange
  "#E91E63", // Pink
  "#8BC34A", // Light Green
  "#00BCD4", // Cyan
  "#FFC107", // Amber
  "#795548", // Brown
  "#607D8B", // Blue Grey
  "#F44336", // Red
  "#3F51B5", // Indigo
  "#009688", // Teal
  "#CDDC39", // Lime
  "#FF5722", // Deep Orange
  "#673AB7", // Deep Purple
  "#03A9F4", // Light Blue
  "#9E9E9E", // Grey
  "#FF6F00", // Orange Accent
  "#1976D2", // Blue 700
];

export const getUserColor = (email: string): string => {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    const char = email.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  const index = Math.abs(hash) % USER_COLORS.length;
  return USER_COLORS[index];
};
